import { BookingDiaryFoldedDaysModel } from './typings/booking-diary.view';

// Saturday and Sunday are index 5 and 6 of a Monday-first week
const FIRST_WEEKEND_INDEX : number = 5;

const FOLDED_DAY_KEYS : { [index : number] : string } = {
  5: 'bookingDiarySaturdayFolded',
  6: 'bookingDiarySundayFolded'
};

// a folded heading keeps the day's short name only
export function foldedDayLabel ( label : string ) : string {
  return label.split(' ')[0];
}

export function isWeekendIndex ( index : number ) : boolean {
  return index >= FIRST_WEEKEND_INDEX;
}

// the choice is the shop's, shared by the week and month views, so it lives in local storage
export function readFoldedDays () : BookingDiaryFoldedDaysModel {
  return {
    5: localStorage.getItem(FOLDED_DAY_KEYS[5]) === 'true',
    6: localStorage.getItem(FOLDED_DAY_KEYS[6]) === 'true'
  };
}

export function writeFoldedDay ( index : number, isFolded : boolean ) : void {
  if ( !FOLDED_DAY_KEYS[index] ) {
    return;
  }

  localStorage.setItem(FOLDED_DAY_KEYS[index], String(isFolded));
}
